<template>
  <div class="view pa24">
    {{ $t('marketing', 'status') }}：
    <el-radio
      v-model="radioValue"
      v-for="(item, index) in radioArr"
      :key="index"
      class="mr10"
      style="margin: 0"
      :label="item.value"
      border
      size="medium"
    >{{ item.label }}</el-radio>
    <el-button type="primary" @click='selectGoodsAssemblePage'>{{ $t('marketing', 'search') }}</el-button>
    <commonTable
      :tableData="tableData"
      :loading="loading"
      @handleSizeChange="handleSizeChange"
      :currentPage="currentPage"
      :total="total"
    >
      <template v-slot:table>
        <el-table-column
          prop="goodsName"
          align="center"
          :label="$t('marketing', 'groupBuyProduct')"
          show-overflow-tooltip
        />
        <el-table-column
          prop="nickeName"
          align="center"
          :label="$t('marketing', 'groupBuyLeader')"
          show-overflow-tooltip
        />
        <el-table-column
          prop="assembleNum"
          align="center"
          :label="$t('marketing', 'groupBuyMinMembers')"
          show-overflow-tooltip
        />
        <el-table-column align="center" :label="$t('marketing', 'groupBuyRemainingMembers')" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.assembleNum - scope.row.putAssemble }}
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('marketing', 'groupBuyTime')" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>{{ $t('marketing', 'start') }}：{{ setGetDataTimeSec(scope.row.startTime) }}</div>
            <div>{{ $t('marketing', 'end') }}：{{ setGetDataTimeSec(scope.row.endTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('marketing', 'groupBuyStatus')" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ getGroupBuyStatusLabel(scope.row.state) }}
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('marketing', 'operation')" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-button type="text" @click="$router.push(`/assembleOrdersInfo?id=${scope.row.assembleId}`)">{{ $t('marketing', 'detail') }}</el-button>
          </template>
        </el-table-column>
      </template>
    </commonTable>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import { selectGoodsAssemblePage } from "@/api/joinGroup";
import { getDataTimeSec } from "@/utils";
import i18nMixin from '@/mixins/i18nMixin';

export default {
  mixins: [i18nMixin],
  name: "listParticipants",
  data() {
    return {
      radioValue: "",
      radioArr: [
        { value: "", label: this.$t('marketing', 'all') },
        { value: "1", label: this.$t('marketing', 'groupBuyInProgress') },
        { value: "2", label: this.$t('marketing', 'groupBuySuccess') },
        { value: "3", label: this.$t('marketing', 'groupBuyFailedPendingRefund') },
        { value: "4", label: this.$t('marketing', 'groupBuyFailedRefunded') },
      ],
      tableData: [],
      currentPage: 1, //当前页
      pageSize: 10, //显示条数
      loading: false, //表格加载
      total: 0, //总条数
    };
  },
  components: {
    commonTable,
  },
  computed: {
    setGetDataTimeSec() {
      return (val) => getDataTimeSec(val);
    },
  },
  created() {
    this.selectGoodsAssemblePage();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
    },
    async selectGoodsAssemblePage() {
      let data = {
        state: this.radioValue,
        pageSize: this.pageSize,
        pageNum: this.currentPage,
      };
      try {
        this.loading = true;
        const result = await selectGoodsAssemblePage(data);
        this.loading = false;
        this.tableData = result?.data;
        this.total = result?.data?.length;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    
    getGroupBuyStatusLabel(state) {
      const statusMap = {
        '1': this.$t('marketing', 'groupBuyInProgress'),
        '2': this.$t('marketing', 'groupBuySuccess'),
        '3': this.$t('marketing', 'groupBuyFailed'),
        '4': this.$t('marketing', 'groupBuyRefunded'),
      };
      return statusMap[state] || this.$t('marketing', 'groupBuyInProgress');
    },
  },
};
</script>

<style lang="scss" scoped>
</style>